export default "__VITE_ASSET__BMm8iRZB__"